import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type SetHasMembershipPayload = {
  hasMembership: boolean | null;
  membershipError: string;
};

export type SetIsLoggedInPayload = {
  isLoggedIn: boolean;
};

export type MembershipState = {
  hasMembership: boolean | null;
  isLoggedIn: boolean;
  membershipError: string;
};

const initialState: MembershipState = {
  hasMembership: null,
  isLoggedIn: false,
  membershipError: '',
};

const membershipSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    setHasMembership: (
      state,
      { payload }: PayloadAction<SetHasMembershipPayload>,
    ) => ({
      ...state,
      hasMembership: payload.hasMembership,
      membershipError: payload.membershipError,
    }),
    setIsLoggedIn: (
      state,
      { payload }: PayloadAction<SetIsLoggedInPayload>,
    ) => ({
      ...state,
      isLoggedIn: payload.isLoggedIn,
    }),
  },
});

export const { setHasMembership, setIsLoggedIn } = membershipSlice.actions;

export default membershipSlice.reducer;
